import { render, staticRenderFns } from "./SendMailShow.vue?vue&type=template&id=25ae422d&scoped=true&"
import script from "./SendMailShow.vue?vue&type=script&lang=js&"
export * from "./SendMailShow.vue?vue&type=script&lang=js&"
import style0 from "./SendMailShow.vue?vue&type=style&index=0&id=25ae422d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ae422d",
  null
  
)

export default component.exports